import { ServiceResult } from '../models';
import {
  CreateRecipeHeaderPrivateUserRequest,
  DeleteRecipeHeaderPrivateUserRequest,
  RecipeHeaderPrivateUser,
  UpdateRecipeHeaderPrivateUsersRequest,
} from '../models/recipe-header-private-user.models';
import ApiService from './api-service';

class RecipeHeaderPrivateUserService extends ApiService {
  private static classInstance: RecipeHeaderPrivateUserService;

  private constructor() {
    super('RecipeHeaderPrivateUser');
  }

  public static getInstance(): RecipeHeaderPrivateUserService {
    if (!this.classInstance) {
      this.classInstance = new RecipeHeaderPrivateUserService();
    }
    return this.classInstance;
  }

  public getRecipeHeaderPrivateUser(recipeHeaderPrivateUserId: string): ServiceResult<RecipeHeaderPrivateUser> {
    return this.get(
      `${this.baseUrl}/GetRecipeHeaderPrivateUser?recipeHeaderPrivateUserId=${recipeHeaderPrivateUserId}`
    );
  }

  public getRecipeHeaderPrivateUsers(
    recipeHeaderId: string,
    viewAsCustomerId: string
  ): ServiceResult<RecipeHeaderPrivateUser[]> {
    return this.get(
      `${this.baseUrl}/GetRecipeHeaderPrivateUsers?recipeHeaderId=${recipeHeaderId}&viewAsCustomerId=${viewAsCustomerId}`
    );
  }

  public getRecipeHeaderPrivateUsersByCustomer(viewAsCustomerId: string): ServiceResult<RecipeHeaderPrivateUser[]> {
    return this.get(`${this.baseUrl}/GetRecipeHeaderPrivateUsersByCustomer?viewAsCustomerId=${viewAsCustomerId}`);
  }

  public createRecipeHeaderPrivateUser(
    request: CreateRecipeHeaderPrivateUserRequest
  ): ServiceResult<RecipeHeaderPrivateUser> {
    return this.post(`${this.baseUrl}/CreateRecipeHeaderPrivateUser`, request);
  }

  public updateRecipeHeaderPrivateUsers(request: UpdateRecipeHeaderPrivateUsersRequest): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/UpdateRecipeHeaderPrivateUsers`, request);
  }

  public deleteRecipeHeaderPrivateUser(request: DeleteRecipeHeaderPrivateUserRequest): ServiceResult<undefined> {
    return this.post(`${this.baseUrl}/DeleteRecipeHeaderPrivateUser`, request);
  }
}

export default RecipeHeaderPrivateUserService;
